<template>
    <div class="mbb-cards-list fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">单卡管理</span>
            <el-form
                inline
                class="right themed-form search-form"
                :model="form"
                style="line-height: 40px"
            >
                <el-form-item label="代理商:">
                    <AgentSelect
                        :multiple="false"
                        v-model="form.agentId"
                        :placeholder="'全部'"
                    />
                </el-form-item>
                <el-form-item label="iccid:">
                    <el-input
                        v-model="form.iccid"
                        placeholder="请输入卡号或短号"
                    />
                </el-form-item>
                <el-form-item label="接入号:">
                    <el-input
                        v-model="form.accessNumber"
                        placeholder="请输入接入号"
                    />
                </el-form-item>
                <el-form-item label="模式:">
                    <el-select v-model="form.mode" clearable placeholder="全部">
                        <el-option label="全部" value="" />
                        <el-option label="代理商池" value="0" />
                        <el-option label="单卡模式" value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select
                        v-model="form.status"
                        clearable
                        placeholder="全部"
                    >
                        <el-option label="全部" value="" />
                        <el-option label="正常" value="0" />
                        <el-option label="停用" value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="onSearch"
                        v-preventReClick
                        >搜索查询</el-button
                    >
                </el-form-item>
                <el-form-item v-if="!isFirstLevelAgent">
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="onOpenImport"
                        v-preventReClick
                        >批量导入</el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="exportChange"
                        v-preventReClick
                        >导出</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="代理商"
                    prop="agentName"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="卡号"
                    prop="iccid"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="短号"
                    prop="shortIccid"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="接入号"
                    prop="accessNumber"
                    show-overflow-tooltip
                />
                <el-table-column label="模式" prop="mode" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ formatMode(scope.row.mode) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="资源点总数"
                    prop="resourcePointsTotal"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="已用资源点"
                    prop="resourcePointsUsed"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="套餐开始时间"
                    prop="packageCycleStart"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="套餐结束时间"
                    prop="packageCycleEnd"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="状态"
                    prop="status"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{ formatStatus(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="备注"
                    prop="remark"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="更新时间"
                    prop="updateTime"
                    show-overflow-tooltip
                />
                <el-table-column
                    v-if="!isFirstLevelAgent"
                    label="操作"
                    width="150"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            size="mini"
                            class="themed-button"
                            @click="handleUpdateMode(scope.row)"
                            v-preventReClick
                            >变更</el-button
                        >
                        <el-button
                            type="danger"
                            size="mini"
                            class="themed-button"
                            @click="handleDelete(scope.row)"
                            v-preventReClick
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            />
        </div>

        <el-dialog
            title="变更模式"
            :visible.sync="updateModeDialogVisible"
            :close-on-click-modal="false"
            width="500px"
        >
            <el-form
                :model="updateModeForm"
                ref="updateModeForm"
                label-width="120px"
            >
                <el-form-item label="卡号/短号:">
                    <el-input v-model="updateModeForm.cardInfo" disabled />
                </el-form-item>
                <el-form-item label="当前模式:">
                    <el-input
                        :value="formatMode(updateModeForm.currentMode)"
                        disabled
                    />
                </el-form-item>
                <el-form-item label="变更模式:" required>
                    <el-radio-group v-model="updateModeForm.mode">
                        <el-radio label="0">代理商池</el-radio>
                        <el-radio label="1">单卡模式</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitUpdateMode"
                    v-preventReClick
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="updateModeDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <el-dialog
            title="批量导入单卡"
            :visible.sync="importDialogVisible"
            :close-on-click-modal="false"
            v-if="importDialogVisible"
            width="620px"
        >
            <el-form
                :model="importForm"
                ref="importForm"
                label-width="150px"
                class="import-form"
            >
                <el-form-item label="模式:" required>
                    <el-radio-group v-model="importForm.mode">
                        <el-radio label="0">代理商池</el-radio>
                        <el-radio label="1">单卡模式</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="导入文件:">
                    <input class="file-input" type="file" ref="file" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >支持 .xls/.xlsx，大小 ≤
                            20M；可二选一（文件或批量输入）</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="批量输入:">
                    <el-input
                        v-model="importForm.cards"
                        type="textarea"
                        :rows="6"
                        placeholder="请输入卡号或短号，每行一条"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="onSubmitImport"
                    v-preventReClick
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="downloadTemplate"
                    v-preventReClick
                    >下载模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="importDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import resize from "@/mixins/resize.js";
import AgentSelect from "@/components/AgentSelect.vue";
import {
    listCards,
    importCardsSync,
    exportCards,
    updateMode,
    deleteCard,
} from "@/api/MbbManagement/cardsList.js";
import { exportTemplate } from "@/api/statistics";
import Utils from "@/utils/utils.js";
import { confirmBox, messageBox } from "@/utils/common.js";
import { mapGetters } from "vuex";

export default {
    name: "MbbCardsList",
    mixins: [resize],
    components: { AgentSelect },
    computed: {
        ...mapGetters(["currentRole"]),
        // 一级代理商账号：隐藏批量导入、变更、删除
        isFirstLevelAgent() {
            const role = this.currentRole;
            return role == 1 || role === "1";
        },
    },
    data() {
        return {
            form: {
                agentId: "",
                iccid: "",
                accessNumber: "",
                mode: "",
                status: "",
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            importDialogVisible: false,
            importForm: {
                mode: "",
                cards: "",
            },
            updateModeDialogVisible: false,
            updateModeForm: {
                id: "",
                cardInfo: "", // 用于显示卡号/短号
                currentMode: "",
                mode: "",
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 列表
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form,
            };
            listCards(params).then((res) => {
                if (res && res.page) {
                    this.tableData = res.page.rows || [];
                    this.total = res.page.total || 0;
                    this.currentPage = res.page.pageNo || 1;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        // 搜索
        onSearch() {
            this.currentPage = 1;
            this.getList();
        },
        // 分页
        handleSizeChange(v) {
            this.pageSize = v;
            this.getList();
        },
        handleCurrentChange(v) {
            this.currentPage = v;
            this.getList();
        },
        // 打开导入
        onOpenImport() {
            this.importForm = { mode: "", cards: "" };
            if (this.$refs.file && this.$refs.file.value) {
                this.$refs.file.value = "";
            }
            this.importDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.importForm &&
                    this.$refs.importForm.clearValidate &&
                    this.$refs.importForm.clearValidate();
            });
        },
        // 提交导入
        async onSubmitImport() {
            if (!this.importForm.mode && this.importForm.mode !== 0) {
                return this.$modal
                    ? this.$modal.msgError("请选择模式")
                    : this.$message.error("请选择模式");
            }
            const file =
                this.$refs.file &&
                this.$refs.file.files &&
                this.$refs.file.files[0];
            const hasText = !!(
                this.importForm.cards && String(this.importForm.cards).trim()
            );
            if (!file && !hasText) {
                return this.$modal
                    ? this.$modal.msgError("请选择文件或输入卡号")
                    : this.$message.error("请选择文件或输入卡号");
            }
            // 简要校验文件（扩展名/大小/文件名长度）
            if (file) {
                const name = file.name || "";
                const ext = name
                    .substring(name.lastIndexOf(".") + 1)
                    .toLowerCase();
                if (!["xls", "xlsx"].includes(ext)) {
                    return this.$modal
                        ? this.$modal.msgError(
                              "文件格式错误，仅支持 .xls/.xlsx"
                          )
                        : this.$message.error(
                              "文件格式错误，仅支持 .xls/.xlsx"
                          );
                }
                const check = Utils.checkFile(file);
                if (check === 1)
                    return this.$modal
                        ? this.$modal.msgError("上传文件不能超过20M")
                        : this.$message.error("上传文件不能超过20M");
                if (check === 2)
                    return this.$modal
                        ? this.$modal.msgError(
                              "上传文件名称长度不能超过36个字符"
                          )
                        : this.$message.error(
                              "上传文件名称长度不能超过36个字符"
                          );
            }
            try {
                await (this.$modal
                    ? this.$modal.confirm("确定导入吗？")
                    : Promise.resolve());
            } catch (e) {
                return;
            }
            const fd = new FormData();
            fd.append("mode", this.importForm.mode);
            if (file) fd.append("fileurl", file);
            if (hasText) fd.append("iccids", this.importForm.cards);
            try {
                this.$modal && this.$modal.loading("导入中...");
                const res = await importCardsSync(fd);
                if (res && String(res.system_result_key) === "0") {
                    const ok = Number(res.import_count || 0);
                    const fails = Number(res.fail_count || 0);
                    const msg = `导入完成：成功 ${ok} 条${
                        fails ? `，失败 ${fails} 条` : ""
                    }`;
                    if (file) {
                        // 文件导入：提示后跳转到导入记录
                        await this.$alert(
                            "导入成功，请到导入记录中下载",
                            "提示",
                            { confirmButtonText: "确定" }
                        );
                        this.importDialogVisible = false;
                        this.$router.push("/tob/i_import_list");
                    } else {
                        // 非文件导入：保留原逻辑（提示+刷新，不跳转）
                        this.$modal
                            ? this.$modal.msgSuccess(msg)
                            : this.$message.success(msg);
                        this.importDialogVisible = false;
                        this.getList();
                    }
                } else {
                    const msg =
                        (res && res.system_result_message_key) || "导入失败";
                    this.$modal
                        ? this.$modal.msgError(msg)
                        : this.$message.error(msg);
                }
            } finally {
                this.$modal &&
                    this.$modal.closeLoading &&
                    this.$modal.closeLoading();
            }
        },
        // 下载批量导入模板（按接口文档文件名）
        downloadTemplate() {
            const name = "importIccidOrShort.xls";
            exportTemplate({ name }).then((res) => {
                Utils.createDownload(res, name);
            });
        },
        // 导出
        exportChange() {
            let params = {
                iccid: this.form.iccid || "",
                accessNumber: this.form.accessNumber || "",
                agentId: this.form.agentId || "",
                mode: this.form.mode || "",
                status: this.form.status || "",
            };
            exportCards(params).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导出成功，请到导出记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.$router.push("/tob/i_export_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },
        // 展示字段
        formatMode(v) {
            const val = v != null ? String(v) : "";
            if (val === "0") return "代理商池";
            if (val === "1") return "单卡模式";
            return "";
        },
        formatStatus(v) {
            const val = v != null ? String(v) : "";
            if (val === "0") return "正常";
            if (val === "1") return "停用";
            return "";
        },
        // 变更模式
        handleUpdateMode(row) {
            const cardInfo = row.iccid || row.shortIccid || "";
            this.updateModeForm = {
                id: row.id || "",
                cardInfo: cardInfo, // 用于显示
                currentMode: row.mode || "",
                mode: "",
            };
            this.updateModeDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.updateModeForm &&
                    this.$refs.updateModeForm.clearValidate &&
                    this.$refs.updateModeForm.clearValidate();
            });
        },
        // 提交变更模式
        submitUpdateMode() {
            if (!this.updateModeForm.mode && this.updateModeForm.mode !== "0") {
                return this.$modal
                    ? this.$modal.msgError("请选择变更模式")
                    : this.$message.error("请选择变更模式");
            }
            if (this.updateModeForm.mode === this.updateModeForm.currentMode) {
                return this.$modal
                    ? this.$modal.msgError("变更模式不能与当前模式相同")
                    : this.$message.error("变更模式不能与当前模式相同");
            }
            const params = {
                id: this.updateModeForm.id,
                mode: this.updateModeForm.mode,
            };
            updateMode(params)
                .then((res) => {
                    if (
                        res.system_result_key == "0" ||
                        res.system_result_key == 0
                    ) {
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                        this.updateModeDialogVisible = false;
                        this.getList();
                    } else {
                        messageBox(
                            this,
                            res.system_result_message_key || "修改失败",
                            "提示"
                        );
                    }
                })
                .catch((err) => {
                    messageBox(
                        this,
                        "请求错误",
                        "操作繁忙请稍后重试或联系客服。"
                    );
                });
        },
        // 删除
        handleDelete(row) {
            const cardInfo = row.iccid || row.shortIccid || "";
            confirmBox(
                this,
                `确定要删除卡号/短号：${cardInfo} 吗？`,
                "删除提示",
                () => {
                    const params = {
                        id: row.id || "",
                    };
                    deleteCard(params)
                        .then((res) => {
                            if (
                                res.system_result_key == "0" ||
                                res.system_result_key == 0
                            ) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                                this.getList();
                            } else {
                                messageBox(
                                    this,
                                    res.system_result_message_key || "删除失败",
                                    "提示"
                                );
                            }
                        })
                        .catch((err) => {
                            messageBox(
                                this,
                                "请求错误",
                                "操作繁忙请稍后重试或联系客服。"
                            );
                        });
                }
            );
        },
    },
};
</script>

<style scoped>
.mbb-cards-list {
    padding: 20px;
}
.content-box {
    margin-bottom: 20px;
}
.pagination {
    text-align: right;
    margin-top: 20px;
}
.mbb-cards-list /deep/ .el-form--inline .el-form-item__content {
    vertical-align: middle;
}
.mt5 {
    margin-top: 5px;
}
.text-color {
    color: #909399;
}
.import-form /deep/ .el-form-item__label {
    white-space: nowrap;
}
</style>


